module.exports = __webpack_public_path__ + "img/LIVRAISON.e2d0e05a.png";